import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps, IGridProps, ListMode } from '../common/props';
import { Row } from '../row/Row';
import { Col } from '../row/Col';
import { ContainerProps } from '../types';

export interface IListProps extends BaseProps {
  /**
   * @deprecated lze nahradit pomocí noHorizontalPadding=true
   */
  simple?: boolean;
  /**
   * @deprecated vzužít raději mode = 'input'
   */
  inputStyle?: boolean;
  /**
   * Vypnutí horizontálního paddingu na položkách listu.
   */
  noHorizontalPadding?: boolean;
  /**
   * Zapnutí horní a spodní oddělovací čáry položek
   */
  topBottomSeparator?: boolean;
  /**
   * Pokud true, tak jsou položky listu zobrazeny jako karty, tento styl se dá aplikovat na libovolný mode.
   */
  cards?: boolean;
  /**
   * Kompaktnější zobrazení - sniží výšku jednotlivých položek listu tím, že bude menší vertikální padding, typicky slouží např. pokud máme jen list jednoduchých textových hodnot.
   * Zapnutím se zmenší i horizontální padding.
   */
  compact?: boolean;
  mode?: ListMode;
  /**
   * Počet akčních tlačítek (POUZE typu icon a uzavřené do ButtonToolbar), které má typicky řádek mít, bude pro ně vyhrazena mezera.
   * Pokud se tedy předá např. hodnota 1, vyhradí se mezera na jedno akční icon tlačítko, pokud se předá 2, vyhradí se mezera na dvě tlačítka + mezera mezi, stejná jako je mezi tlařítky v ButtonToolbar.
   */
  extraSize?: number;

  gridProps?: IGridProps;
  listItemHeaderWidth?: number;
}

export type ListProps = IListProps & ContainerProps;

export interface ListExtraSize {
  extraSize?: number;
  headerWidth?: number;
}

export const ListExtraSizeContext = React.createContext<ListExtraSize>({});
/**
 * Komponenta kartičky.
 */
export class List extends React.PureComponent<ListProps> {
  render() {
    const {
      className,
      simple,
      cards,
      noHorizontalPadding,
      topBottomSeparator,
      style,
      children,
      compact,
      inputStyle,
      extraSize,
      mode = 'default',
      gridProps,
      fullHeight,
      noScroll,
      maxFullHeight,
      listItemHeaderWidth,
      ...other
    } = this.props;

    let cls = classNames(Classes.LIST, className, {
      [Classes.LIST_NO_PADDING]: noHorizontalPadding || simple,
      [Classes.LIST_NO_TB_ROWS]: !topBottomSeparator,
      [Classes.LIST_COMPACT]: compact,
      [Classes.LIST_MODE_DEFAULT]: mode === 'default',
      [Classes.LIST_MODE_EDIT]: mode === 'edit',
      [Classes.LIST_MODE_VIEW]: mode === 'view',
      [Classes.LIST_MODE_LABELS]: mode === 'labels',
      [Classes.LIST_MODE_CARDS]: cards,
      [Classes.LIST_MODE_FORM]: mode === 'form',
      [Classes.HOVER_DISABLE_ITEMS]: mode === 'labels',
      [Classes.LIST_MODE_INPUT]: mode === 'input' || inputStyle,
      [Classes.CONTAINER_FULL_HEIGHT]: fullHeight,
      [Classes.NO_SCROLL]: noScroll,
      [Classes.CONTAINER_MAX_HEIGHT]: maxFullHeight,
    });

    return (
      <ListExtraSizeContext.Provider
        value={{ extraSize, headerWidth: listItemHeaderWidth }}
      >
        <div {...other} className={cls} style={style}>
          <div className={classNames(Classes.LIST_CONTAINER)}>
            {mode !== 'grid' && children}
            {mode === 'grid' && (
              <Row className={Classes.LIST_MODE_GRID}>
                {React.Children.map(children, (child, index) => (
                  <Col key={index} {...gridProps}>
                    {child}
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </div>
      </ListExtraSizeContext.Provider>
    );
  }
}
